<script setup lang="ts">
const route = useRoute()
</script>

<template>
  <header
    :class="{
      page: route.name === 'page-slug',
    }"
    class="px-bleed fixed top-0 left-0 z-99 flex h-14 w-full items-center justify-between font-mono text-xs uppercase select-none"
  >
    <div
      class="breadcrumbs ease-in-out-quint relative inline-flex h-full gap-2 py-2 transition-transform duration-1000"
      :class="{ 'max-lg:translate-x-[calc(50vw-50%-12px)]': route.name !== 'page-slug' }"
    >
      <NuxtLink to="/" class="flex h-full w-auto items-center" aria-label="Home">
        <NitexLogo class="h-4 text-(--logo) transition-colors" />
      </NuxtLink>

      <Transition :appear="true" name="clip-reveal" mode="out-in">
        <div
          v-if="route.meta.pageTitle && route.name === 'page-slug'"
          :key="route.fullPath"
          class="absolute top-1/2 left-full ml-2 flex -translate-y-1/2 whitespace-nowrap"
        >
          / {{ route.meta.pageTitle }}
        </div>
      </Transition>
    </div>
  </header>
</template>

<style scoped>
.safari-blur:before {
  -webkit-backdrop-filter: blur(16px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.clip-reveal-enter-active,
.clip-reveal-leave-active {
  transition: clip-path 0.6s ease-in-out;
}

.clip-reveal-enter-from,
.clip-reveal-leave-to {
  clip-path: polygon(-100% 0%, 0% 0%, -05% 100%, -100% 100%);
}

.clip-reveal-enter-to,
.clip-reveal-leave-from {
  clip-path: polygon(-100% 0%, 105% 0%, 100% 100%, -100% 100%);
}
</style>
